import request from '@/utils/request'


// 查询学校负责人列表
export function listSchoolLeader(query) {
  return request({
    url: '/biz/admin/school/leader/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询学校负责人分页
export function pageSchoolLeader(query) {
  return request({
    url: '/biz/admin/school/leader/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询学校负责人详细
export function getSchoolLeader(data) {
  return request({
    url: '/biz/admin/school/leader/detail',
    method: 'get',
    params: data
  })
}

// 新增学校负责人
export function addSchoolLeader(data) {
  return request({
    url: '/biz/admin/school/leader/add',
    method: 'post',
    data: data
  })
}

// 修改学校负责人
export function updateSchoolLeader(data) {
  return request({
    url: '/biz/admin/school/leader/edit',
    method: 'post',
    data: data
  })
}

// 删除学校负责人
export function delSchoolLeader(data) {
  return request({
    url: '/biz/admin/school/leader/delete',
    method: 'post',
    data: data
  })
}
